import { node, oneOf } from "prop-types";

import { fontWeightOptions } from "../constants/fontWeightOptions";
import * as S from "./styled";

const SecondaryLarge = S.SecondaryLargeBase;

SecondaryLarge.displayName = "SecondaryLarge";

SecondaryLarge.propTypes = {
  children: node.isRequired,
  weight: oneOf([fontWeightOptions.LIGHT, fontWeightOptions.REGULAR])
};

SecondaryLarge.defaultProps = {
  weight: fontWeightOptions.LIGHT
};

export default SecondaryLarge;
